import React from "react";
import QRCodeGenerator from "../../utils/qrcode";

function LeaderProfileQRCode({ url, t }) {
  return (
    <div style={{ textAlign: "center", marginTop: "0px" }}>
      <div style={{ margin: "0" }}>{t("leader_profile.share")}</div>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          marginTop: "0"
        }}
      >
        <QRCodeGenerator url={url} width={200} />
      </div>
    </div>
  );
}

export default LeaderProfileQRCode;
